import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";

import { toast } from "react-toastify";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import Pagination from "../../../Components/Common/Pagination";
import {
  editUserCoins,
  getUsers,
  toggleUserBlock,
} from "../../../slices/1-user/thunk";

const UsersTable = () => {
  const [modal_list, setmodal_list] = useState(false);
  const dispatch = useDispatch();
  const [editModal, setEditModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [coins, setCoins] = useState("");
  const [nameAR, setNameAR] = useState("");
  const [nameEN, setNameEN] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [price, setPrice] = useState("");
  const [typeFilter, setTypeFilter] = useState(" ");

  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isBlockedStatus, setIsBlockedStatus] = useState(false);

  const [viewModal, setViewModal] = useState(false);
  const [viewUser, setViewUser] = useState(null);

  const { users, loading, error, totalPages } = useSelector(
    (state) => state.Users,
  );

  const [page, setPage] = useState(1);
  const limit = 10;

  useEffect(() => {
    dispatch(getUsers({ page, limit }));
  }, [dispatch, page]);

  const handleSubmit = (e) => {
    // e.preventDefault();
    // const commodityData = {
    //   name_AR: nameAR,
    //   name_EN: nameEN,
    //   price: Number(price),
    //   index: Number(index),
    // };
    // dispatch(addCommodity(commodityData))
    //   .unwrap()
    //   .then(() => {
    //     setmodal_list(false);
    //     setNameAR("");
    //     setNameEN("");
    //     setPrice("");
    //     setIndex("");
    //     dispatch(getUsers({ page, limit, search: searchTerm }));
    //   })
    //   .catch((err) => {
    //     toast.error(err?.message || "حدث خطأ", { autoClose: 3000 });
    //   });
  };

  const handlePatchActive = (user) => {
    setSelectedUserId(user._id);
    setIsBlockedStatus(user?.isBlocked);
    setDeleteModal(true);
  };

  const confirmToggleBlock = () => {
    if (selectedUserId) {
      dispatch(toggleUserBlock(selectedUserId));
      setDeleteModal(false);
      setSelectedUserId(null);
    }
  };

  const openCoinsModal = (user) => {
    setSelectedUser(user);
    setCoins(user.coins);
    setEditModal(true);
  };

  const handleEditSubmit = (e) => {
    e.preventDefault();

    dispatch(
      editUserCoins({
        id: selectedUser._id,
        coins: Number(coins),
      }),
    )
      .unwrap()
      .then(() => {
        setEditModal(false);
        dispatch(getUsers({ page, limit }));
      })
      .catch((err) => {
        toast.error(err?.message || "فشل التعديل");
      });
  };

  const tog_list = () => {
    setmodal_list(!modal_list);
  };

  const openViewModal = (user) => {
    setViewUser(user);
    setViewModal(true);
  };

  document.title = "Category";

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchTerm?.length >= 3 || searchTerm?.length === 0) {
        dispatch(getUsers({ page, limit, search: searchTerm }));
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [dispatch, page, searchTerm]);

  // console.log(users);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="إدارة المستخدمين" />
          <Row>
            <Col lg={12}>
              <Card style={{ borderRadius: "16px" }}>
                <CardBody>
                  <div className="listjs-table" id="tagsList">
                    <Row className="g-4 mb-3">
                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-start">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="بحث..."
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <i className="ri-search-line search-icon"></i>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <div className="table-responsive table-card mt-3 mb-1">
                      <table
                        className="table align-middle table-nowrap"
                        id="customerTable"
                      >
                        <thead className="table-light text-center">
                          <tr>
                            <th>اسم المستخدم</th>
                            <th>البريد الإلكتروني</th>
                            <th>رقم الهاتف</th>
                            <th>الكوينز</th>
                            <th>الحالة</th>
                            <th>إجراءات</th>
                          </tr>
                        </thead>
                        <tbody className="list form-check-all  text-center">
                          {users && users?.length > 0 ? (
                            users?.map((item) => (
                              <tr key={item.id} className="fs-5">
                                <td className="id" style={{ display: "none" }}>
                                  <Link
                                    to="#"
                                    className="fw-medium link-primary"
                                  >
                                    {item._id}
                                  </Link>
                                </td>
                                <td className="fullName">{item.fullName}</td>
                                <td className="email">{item.email}</td>
                                <td className="phone">{item.phone}</td>
                                <td className="coins">{item.coins}</td>
                                <td>
                                  <span
                                    className={`badge rounded-pill ${
                                      !item.isBlocked
                                        ? "bg-success"
                                        : "bg-danger"
                                    }`}
                                  >
                                    {!item.isBlocked ? "نشط" : "محظور"}
                                  </span>
                                </td>
                                <td>
                                  <div className="d-flex gap-3 justify-content-center">
                                    {/* Block / Unblock */}
                                    <button
                                      style={{
                                        background: "transparent",
                                        border: "none",
                                      }}
                                      onClick={() => handlePatchActive(item)}
                                    >
                                      <i
                                        className={
                                          item.isBlocked
                                            ? "ri-lock-unlock-line"
                                            : "ri-forbid-line"
                                        }
                                        style={{
                                          color: item.isBlocked
                                            ? "green"
                                            : "red",
                                          fontSize: "20px",
                                        }}
                                      ></i>
                                    </button>

                                    {/* Coins */}
                                    <button
                                      style={{
                                        background: "transparent",
                                        border: "none",
                                      }}
                                      onClick={() => openCoinsModal(item)}
                                    >
                                      <i
                                        className="ri-coins-line"
                                        style={{
                                          color: "#f1c40f",
                                          fontSize: "20px",
                                        }}
                                      ></i>
                                    </button>

                                    <button
                                      style={{
                                        background: "transparent",
                                        border: "none",
                                      }}
                                      onClick={() => openViewModal(item)}
                                    >
                                      <i
                                        className="ri-eye-line"
                                        style={{
                                          color: "#3498db",
                                          fontSize: "20px",
                                        }}
                                      ></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center">
                                لا يوجد مستخدمين
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {/* Pagination */}
                    <div className="row g-0 text-center text-sm-start align-items-center mb-4">
                      <div className="col-sm-6"></div>
                      <div className="col-sm-6">
                        <Pagination
                          currentPage={page}
                          totalPages={totalPages}
                          onPageChange={(newPage) => {
                            setPage(newPage);
                            window.scrollTo({
                              top: 0,
                              behavior: "smooth",
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Add Modal */}
      {/* <Modal
        isOpen={modal_list}
        toggle={() => {
          tog_list();
        }}
        centered
      >
        <ModalHeader
          className="bg-light p-3"
          toggle={() => {
            tog_list();
          }}
        >
          {" "}
          إضافة سلعة{" "}
        </ModalHeader>
        <form className="tablelist-form" onSubmit={handleSubmit}>
          <ModalBody>
            <div className="mb-3">
              <label htmlFor="name-ar-field" className="form-label">
                الاسم (عربى)
              </label>
              <input
                type="text"
                id="name-ar-field"
                className="form-control"
                placeholder="إدخل الاسم"
                onChange={(e) => setNameAR(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="name-en-field" className="form-label">
                الاسم (إنجليزي)
              </label>
              <input
                type="text"
                id="name-en-field"
                className="form-control"
                placeholder="إدخل الاسم"
                onChange={(e) => setNameEN(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">السعر</label>
              <input
                type="number"
                className="form-control"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">الترتيب</label>
              <input
                type="number"
                className="form-control"
                value={index}
                onChange={(e) => setIndex(e.target.value)}
                required
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => setmodal_list(false)}
              >
                غلق
              </button>
              <button type="submit" className="btn btn-success" id="add-btn">
                إضافة
              </button>
            </div>
          </ModalFooter>
        </form>
      </Modal> */}

      {/* Edit Modal */}
      <Modal isOpen={editModal} toggle={() => setEditModal(false)} centered>
        <ModalHeader
          className="bg-light p-3"
          toggle={() => setEditModal(false)}
        >
          تعديل الكوينز
        </ModalHeader>

        <form className="tablelist-form" onSubmit={handleEditSubmit}>
          <ModalBody>
            <div className="mb-3">
              <label className="form-label">الكوينز</label>
              <input
                type="number"
                className="form-control"
                value={coins}
                min="1"
                onChange={(e) => {
                  const value = Math.max(1, Number(e.target.value));
                  setCoins(value);
                }}
                required
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => setEditModal(false)}
              >
                غلق
              </button>
              <button type="submit" className="btn btn-primary">
                حفظ
              </button>
            </div>
          </ModalFooter>
        </form>
      </Modal>

      {/* Confirm Toggle Block Modal */}
      <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)} centered>
        <ModalHeader toggle={() => setDeleteModal(false)}>
          تأكيد الإجراء
        </ModalHeader>
        <ModalBody>
          <div className="mt-2 text-center">
            <i
              className={`ri-information-line display-3 ${isBlockedStatus ? "text-success" : "text-danger"}`}
            ></i>
            <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
              <h4>هل أنت متأكد؟</h4>
              <p className="text-muted mx-4 mb-0">
                هل تريد حقاً {isBlockedStatus ? "إلغاء حظر" : "حظر"} هذا
                المستخدم؟
              </p>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="hstack gap-2 justify-content-center w-100">
            <Button color="light" onClick={() => setDeleteModal(false)}>
              إلغاء
            </Button>
            <Button
              color={isBlockedStatus ? "success" : "danger"}
              onClick={confirmToggleBlock}
            >
              نعم، {isBlockedStatus ? "إلغاء الحظر" : "إتمام الحظر"}
            </Button>
          </div>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={viewModal}
        toggle={() => setViewModal(false)}
        centered
        size="lg"
      >
        <ModalHeader
          toggle={() => setViewModal(false)}
          className="border-0 pb-0"
        >
          بيانات المستخدم
        </ModalHeader>

        <ModalBody className="pt-2">
          {viewUser && (
            <div className="p-3">
              {/* Top User Info */}
              <div className="d-flex align-items-center gap-3 mb-4 pb-4 border-bottom">
                {viewUser.avatar ? (
                  <img
                    src={viewUser.avatar}
                    alt={viewUser.fullName}
                    className="rounded-circle"
                    style={{
                      width: "70px",
                      height: "70px",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <div
                    className="d-flex align-items-center justify-content-center rounded-circle bg-primary text-white"
                    style={{
                      width: "70px",
                      height: "70px",
                      fontSize: "28px",
                      fontWeight: "bold",
                    }}
                  >
                    {viewUser?.fullName?.charAt(0)}
                  </div>
                )}

                <div>
                  <h4 className="mb-1">{viewUser.fullName}</h4>

                  <div className="text-muted">@{viewUser.username}</div>

                  <div className="mt-2">
                    <span
                      className={`badge rounded-pill ${
                        !viewUser.isBlocked ? "bg-success" : "bg-danger"
                      }`}
                    >
                      {!viewUser.isBlocked ? "نشط" : "محظور"}
                    </span>
                  </div>
                </div>
              </div>

              {/* Info Grid */}
              <Row className="g-4">
                <Col md={6}>
                  <div className="border rounded-4 p-3 h-100">
                    <div className="text-muted mb-1">البريد الإلكتروني</div>
                    <div className="fw-semibold">{viewUser.email || "-"}</div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="border rounded-4 p-3 h-100">
                    <div className="text-muted mb-1">رقم الهاتف</div>
                    <div className="fw-semibold">{viewUser.phone || "-"}</div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="border rounded-4 p-3 h-100">
                    <div className="text-muted mb-1">الكود</div>
                    <div className="fw-semibold">{viewUser.code}</div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="border rounded-4 p-3 h-100">
                    <div className="text-muted mb-1">الكوينز</div>
                    <div className="fw-bold text-warning">{viewUser.coins}</div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="border rounded-4 p-3 h-100">
                    <div className="text-muted mb-1">عدد المباريات</div>
                    <div className="fw-semibold">
                      {viewUser?.stats?.totalMatches || 0}
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="border rounded-4 p-3 h-100">
                    <div className="text-muted mb-1">الإجابات الصحيحة</div>
                    <div className="fw-semibold">
                      {viewUser?.stats?.totalCorrect || 0}
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="border rounded-4 p-3 h-100">
                    <div className="text-muted mb-1">تاريخ التسجيل</div>
                    <div className="fw-semibold">
                      {new Date(viewUser.createdAt).toLocaleDateString("ar-EG")}
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="border rounded-4 p-3 h-100">
                    <div className="text-muted mb-1">نوع الحساب</div>
                    <div className="fw-semibold text-capitalize">
                      {viewUser.role}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default UsersTable;
